module.exports = __webpack_public_path__ + "img/created_mind.e2ecd80e.svg";